class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-search-results]');
    this.hint = document.getElementById('SearchHint');
    this.abortController = null;

    this.input.addEventListener('input', this.debounce((event) => this.onChange(event), 300).bind(this));
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onChange() {
    const term = this.input.value.trim();
    if (!term.length) {
      this.close();
      return;
    }
    this.getResults(term);
  }

  getResults(term) {
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    fetch(`${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(term)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');
        this.results.innerHTML = section ? section.innerHTML : '';
        this.open();
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        this.close();
      });
  }

  open() {
    this.results.hidden = false;
    if (this.hint) this.hint.hidden = true;
  }

  close() {
    this.results.hidden = true;
    this.results.innerHTML = '';
    if (this.hint) this.hint.hidden = false;
  }
}

customElements.define('predictive-search', PredictiveSearch);
